<template>
  <div class="custom-card table-wrapper" v-loading="loading">
    <div class="mb-5">
      <div class="flex border-b-2 border-gray-400 pt-2">
        <div
          class="tab-item"
          :class="{ active: currentTab == 'My Fleet' }"
          @click="currentTab = 'My Fleet'"
        >
          <p>My Fleet</p>
        </div>
        <div
          class="tab-item"
          :class="{ active: currentTab == 'Leased Fleet' }"
          @click="currentTab = 'My Fleet'"
        >
          <p>Leased Fleet</p>
        </div>
      </div>
    </div>
    <div class="flex justify-between">
      <div class="group-options-select">
        <div class="flex">
          <div
            class="mr-2  p-2 px-3 filter cursor-pointer hover:shadow-sm "
            :class="{ 'shadow-sm': sortList }"
            @click="sortList = !sortList"
          >
            <img src="@/assets/images/icons/filter.svg" alt="filter icon" />
          </div>

          <div class="table__search-input-wrapper">
            <span class="pr-2 opacity-50">
              <search-icon />
            </span>
            <input
              type="text"
              class="table__search-input"
              placeholder="Search..."
              v-model="queryString"
            />
            <img src="@/assets/images/icons/search.svg" alt="search icon" />
          </div>
        </div>
      </div>
      <span>
        <el-dropdown v-if="$_isAdmin" class="h-full text-black" trigger="click">
          <button
            class="payment-assignqs h-full font-semibold  flex items-center "
          >Add New Vehicle
              <i class="ml-2">
                <svg
                width="10"
                height="7"
                viewBox="0 0 10 7"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1.38672L5 5.38672L9 1.38672"
                  stroke="#10233E"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              </i>
          </button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <button @click="showFleettypeModal">Add New Vehicle</button>
            </el-dropdown-item>

            <!-- <el-dropdown-item>
              <button @click="showExistingFleet = true">From Existing Vehicle</button>
            </el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </div>

    <table class="custom-table responsive-table">
      <thead>
        <tr class="shadow-table rounded-md">
          <th>Name</th>
          <th>VIN</th>
          <th>Vehicle Type</th>
          <th>Driver</th>
          <th>Fleet Type</th>
          <th>Carriage Capacity</th>
          <th>Date Registered</th>
          <th>Vehicle Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="!loading && !filteredFleets.length">
        <tr class="shadow-table rounded-md">
          <td colspan="7">
            <div class="flex flex-col justify-center items-center gap-4">
              <empty-fleets-icon />
              <p>No Fleet to display!</p>
              <router-link
                class="no-underline hover:no-underline"
                :to="{ name: 'NewVehicle' }"
              >
                <div
                  class="flex gap-2 text-primary-yellow text-center text-sm font-bold cusror-pointer"
                  @click="isNewLocationModal = true"
                >
                  <span>
                    <svg
                      width="23"
                      height="23"
                      viewBox="0 0 23 23"
                      fill="#FCC210"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.5 22.3672C5.42487 22.3672 0.5 17.4423 0.5 11.3672C0.5 5.29206 5.42487 0.367188 11.5 0.367188C17.5751 0.367188 22.5 5.29206 22.5 11.3672C22.5 17.4423 17.5751 22.3672 11.5 22.3672ZM11.5 20.3672C16.4706 20.3672 20.5 16.3378 20.5 11.3672C20.5 6.39662 16.4706 2.36719 11.5 2.36719C6.52944 2.36719 2.5 6.39662 2.5 11.3672C2.5 16.3378 6.52944 20.3672 11.5 20.3672ZM16.5 10.3672H12.5V6.36719H10.5V10.3672H6.5V12.3672H10.5V16.3672H12.5V12.3672H16.5V10.3672Z"
                        fill="#FCC210"
                      />
                    </svg>
                  </span>
                  Start Adding Fleet
                </div>
              </router-link>
            </div>
          </td>
        </tr>
      </tbody>

      <tbody
        v-if="!loading && filteredFleets.length && currentTab != 'Leased Fleet'"
      >
        <tr
          v-for="fleet in paginatedList"
          :key="fleet.id"
          class="shadow-table rounded-md"
        >
          <td>{{ fleet.equipment }}</td>
          <td>{{ fleet.vinnumber }}</td>
          <td>{{ fleet.vehicletype }}</td>
          <td>{{ fleet.driver ? fleet.driver.firstname + ' ' + fleet.driver.lastname : "" }}</td>
          <td>
            <span class="flex item-center"
              >{{ fleet.fleetType }}
              <img
                v-if="fleet.request"
                src="@/assets/images/icons/red_vehicle.svg"
                class="ml-1"
            /></span>
          </td>
          <td>
            {{
              fleet.currentLoadCapacity
                ? parseFloat(fleet.currentLoadCapacity).toFixed(2)
                : "N.A"
            }}
          </td>
          <td>
            {{ new Date(fleet.createdAt).toLocaleDateString("en-gb") }}
          </td>
          <td>
            <span v-if="fleet.fleetstatus === 'active'" class="text-success">{{
              fleet.fleetstatus | capitalize
            }}</span>

            <span v-else class="text-danger">{{
              fleet.fleetstatus | capitalize
            }}</span>
          </td>
          <td>
            <el-dropdown>
              <button class="px-4">
                <vertical-ellipsis />
              </button>

              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <button @click="viewSingleVehicleNX(fleet)">
                    <span class="flex item-center">
                      <img
                        src="@/assets/images/icons/yellow_eye.svg"
                        class="mr-2"
                      />
                      View</span
                    >
                  </button>
                </el-dropdown-item>
                <el-dropdown-item v-if="$_isAdmin">
                  <button @click="viewEditVehicle(fleet)">
                    <span class="flex item-center">
                      <img
                        src="@/assets/images/icons/green_edit.svg"
                        class="mr-2"
                      />
                      Edit
                    </span>
                  </button>
                </el-dropdown-item>
                <el-dropdown-item v-if="fleet.request && $_isAdmin">
                  <button @click="viewVehicleRequest(fleet)">
                    <span class="flex item-center">
                      <img
                        src="@/assets/images/icons/eye_gray.svg"
                        class="mr-2"
                      />
                      View Request
                    </span>
                  </button>
                </el-dropdown-item>
                <el-dropdown-item v-if="$_isAdmin">
                  <button
                    class="flex items-center"
                    @click="(isDeleteModal = true), (selectedId = fleet.id)"
                  >
                    <span class="flex item-center">
                      <img
                        src="@/assets/images/icons/red_delete.svg"
                        class="mr-2"
                      />
                      Delete
                    </span>
                  </button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </td>
        </tr>
      </tbody>

      <tbody
        v-if="!loading && filteredFleets.length && currentTab == 'Leased Fleet'"
      >
        <tr
          v-for="fleet in paginatedList"
          :key="fleet.id"
          class="shadow-table rounded-md"
        >
          <td>{{ fleet.fleet.equipment }}</td>
          <td>{{ fleet.fleet.vinnumber }}</td>
          <td>{{ fleet.fleet.vehicletype }}</td>
          <td>
            {{ fleet.fleet.driver.firstname }} {{ fleet.fleet.driver.lastname }}
          </td>
          <td>
            <span class="flex item-center">{{ fleet.fleet.fleetType }} </span>
          </td>
          <td>
            {{
              fleet.fleet.currentLoadCapacity
                ? parseFloat(fleet.fleet.currentLoadCapacity).toFixed(2)
                : "N.A"
            }}
          </td>
          <td>
            {{ new Date(fleet.createdAt).toLocaleDateString("en-gb") }}
          </td>
          <td>
            <span
              v-if="fleet.fleet.fleetstatus === 'active'"
              class="text-success"
              >{{ fleet.fleet.fleetstatus | capitalize }}</span
            >

            <span v-else class="text-danger">{{
              fleet.fleet.fleetstatus | capitalize
            }}</span>
          </td>
          <td>
            <el-dropdown>
              <button class="px-4">
                <vertical-ellipsis />
              </button>

              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <button @click="viewSingleVehicleNX(fleet.fleet)">
                    <span class="flex item-center">
                      <img
                        src="@/assets/images/icons/yellow_eye.svg"
                        class="mr-2"
                      />
                      View</span
                    >
                  </button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <button @click="viewEditVehicle(fleet.fleet)">
                    <span class="flex item-center">
                      <img
                        src="@/assets/images/icons/green_edit.svg"
                        class="mr-2"
                      />
                      Edit
                    </span>
                  </button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <button @click="viewVehicleRequest(fleet)">
                    <span class="flex item-center">
                      <img
                        src="@/assets/images/icons/eye_gray.svg"
                        class="mr-2"
                      />
                      View Request
                    </span>
                  </button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <button
                    class="flex items-center"
                    @click="(isDeleteModal = true), (selectedId = fleet.id)"
                  >
                    <span class="flex item-center">
                      <img
                        src="@/assets/images/icons/red_delete.svg"
                        class="mr-2"
                      />
                      Delete
                    </span>
                  </button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </td>
        </tr>
      </tbody>
    </table>

    <pagination
      :total="totalFleets"
      :pageNumber="pageNumber"
      @pageNumber="setNumDisplayLocation"
      @pageSize="pageSize"
    />

    <edit-fleet-modal
      :fleet="selectedFleet"
      :routes="routes"
      :fleetID="selectedFleet.id"
      :showModal="showEditModal"
      @close-modal="showEditModal = false"
    />

    <delete-modal
      :showModal="isDeleteModal"
      :itemToDelete="itemToDelete"
      :deletingItem="deletingFleet"
      @close-modal="isDeleteModal = false"
      @delete-item="deleteFleet"
    />
    <FleetTypeModal
      :show-modal="showFleetType"
      @close-modal="showFleetType = false"
    />
    <ViewRequestModal
      :show-modal="showViewRequest"
      @close-modal="showViewRequest = false"
      :selectedFleet="selectedFleet"
    />

    <ExistingFleet
    :show-modal="showExistingFleet"
    @close-modal="showExistingFleet = false"
  />
  </div>
</template>

<script>
import pagination from "../../../../UI/pagination.vue";
import EditFleetModal from "./EditFleetModal.vue";
import FleetTypeModal from "./FleetTypeModal.vue";
import ViewRequestModal from "./ViewRequestModal.vue";
import ExistingFleet from "./ExistingFleet.vue";

export default {
  components: {
    pagination,
    EditFleetModal,
    FleetTypeModal,
    ViewRequestModal,
    ExistingFleet
  },
  data() {
    return {
      loading: false,
      fleets: [],
      selectedFleet: {},
      isDeleteModal: false,
      showEditModal: false,
      itemToDelete: "Vehicle",
      selectedId: null,
      deletingFleet: false,
      showFleetType: false,
      queryString: "",
      sortList: false,
      routes: [],
      totalFleets: 1,
      fleetsPerPage: 10,
      pageNumber: 1,
      currentTab: "My Fleet",
      showViewRequest: false,
      showExistingFleet: false
    };
  },
  mounted() {
    this.getFleets();
    this.getAllRoutes(this.setparams);
  },
  computed: {
    filteredFleets() {
      return this.filterArray(this.fleets, this.queryString);
    },
    lists() {
      return this.sortList
        ? this.filteredFleets
            .map((l) => l)
            .sort((a, b) => {
              var x = a.equipment.toLowerCase();
              var y = b.equipment.toLowerCase();
              return x > y ? -1 : x > y ? 1 : 0;
            })
        : this.filteredFleets;
    },
    startRange() {
      return (this.pageNumber - 1) * Number(this.fleetsPerPage);
    },
    endRange() {
      return this.pageNumber * Number(this.fleetsPerPage);
    },
    paginatedList() {
      return this.lists.filter(
        (item, index) => index >= this.startRange && index < this.endRange
      );
    },
    setparams() {
      return { pageSize: this.fleetsPerPage, pageNum: this.pageNumber };
    },
  },
  watch: {
    setparams() {
      this.getFleets(this.setparams);
    },
    currentTab() {
      this.getFleets(this.setparams);
    },
  },
  methods: {
    viewRequest() {},
    showFleettypeModal() {
      this.showFleetType = true;
    },
    pageSize(val) {
      this.fleetsPerPage = val;
    },
    setNumDisplayLocation(val) {
      this.pageNumber = val;
    },
    async getSingleFleet(id) {
      this.loading = true;

      try {
        const { data: response } = await this.$_getSingleFleet(id);

        this.fleets = response.data;
        this.loading = false;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async getFleets(params) {
      this.loading = true;
      this.currentTab != "Leased Fleet"
        ? await this.getUserFleets(params)
        : await this.getLeasedFleets(params);
    },
    async getLeasedFleets(params) {
      this.loading = true;

      try {
        const response = await this.$_getLeasedFleet(params);
        this.fleets = response?.data?.publicFleets;
        // this.totalFleets = response?.data?.data?.totalCount;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async getUserFleets(params) {
      this.loading = true;

      try {
        const response = await this.$_getUserMyFleet(params);
        this.fleets = response?.data?.data;
        // this.totalFleets = response.data?.totalCount;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async deleteFleet() {
      this.deletingFleet = true;
      try {
        await this.$_deleteFleet(this.selectedId);

        this.generateToast("fleet successfully deleted!", "success");
        this.getFleets();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isDeleteModal = false;
        this.deletingFleet = false;
      }
    },

    showDeleteModal(fleet) {
      this.selectedId = fleet.id;
      this.isDeleteModal = true;
    },

    showActionOptions(id) {
      if (!this.selectedId) {
        this.selectedId = id;
      } else {
        this.selectedId = null;
      }
    },

    viewSingleVehicle(vehicleId) {
      localStorage.setItem("vehicleId", vehicleId);
      this.$router.push({ name: "SingleVehicle" });
    },

    viewEditVehicle(vehicleId) {
      this.selectedFleet = vehicleId;
      this.$router.push(`/settings/vehicles/edit-vehicle/${vehicleId.id}`);
    },
    viewSingleVehicleNX(fleet) {
      this.selectedFleet = fleet;
      this.$router.push(`/settings/vehicles/view-vehicle/${fleet.id}`);
    },
    viewVehicleRequest(vehicleId) {
      this.selectedFleet = vehicleId;
      this.showViewRequest = true;
    },

    async getAllRoutes() {
      try {
        const { data: response } = await this.$_getAllRoutes();

        this.routes = response.data.shippingServices;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.primary {
  background: #09b78a1a;
  color: #09b78a;
  padding: 0.5rem;
  border-radius: 2px;
}

.table-wrapper {
  margin: 3rem 0;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

.table-header__col-two {
  display: flex;
}

.table__btn {
  padding: 0.45rem 0.85rem;
  color: #ffffff;
  font-size: 0.85rem;
  border-radius: 3px;
}

.table__search-input-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f2f1;
  height: 2.25rem;
  width: 30vw;
  border-radius: 15px;
  padding: 0 1rem;
  margin-right: 1.5rem;
}

.table__search-input {
  background: transparent;
  color: #343633;
  font-size: 0.9rem;
  width: 100%;
  height: 100%;
}

.table__search-input:focus {
  outline: none;
}

.table__search-input::placeholder {
  color: #343633;
  font-size: 0.9rem;
}

.custom-table {
  margin: 2rem 0;
  width: 100%;
}

.custom-table th {
  color: #060e18;
  font-weight: 600;
}

.custom-table th,
td {
  padding: 1rem;
  font-size: 0.9rem;
}

.custom-table td {
  color: #343633;
}

.table__action-btn {
  position: relative;
  padding: 0;
}

.table__action-options {
  position: absolute;
  width: 8rem;
  padding: 0.5rem 0;
  right: 2rem;
  background: #ffffff;
  z-index: 999;
  border-radius: 3px;
  box-shadow: 0px 0px 12px #dee0e7;
}

.table__action-option {
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
}

.table__action-option:hover {
  background: #fce4da;
}

.table__action-btn span {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .table__search-input-wrapper {
    width: 100%;
  }

  .table__btn-wrapper {
    width: 100%;
  }

  .button {
    width: 100%;
    margin-bottom: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .table-header__col-two {
    flex-direction: column-reverse;
  }
}
.tab-item {
  cursor: pointer;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  @apply bg-gray-300;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
.payment-assignqs{
  @apply bg-primary-yellow px-3;
  color: black
}
</style>
